<template>
    <div>

        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="success" :size="GCONFIG.styleElFormSize" @click="handleAdd">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="level" label="等级编号" width="200"></el-table-column>
            <el-table-column prop="levelName" label="等级名称" width="200"></el-table-column>
            <el-table-column prop="levelType" label="等级类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.levelType==1">订单升级</span>
                    <span v-if="scope.row.levelType==2">付费升级</span>
                </template>
            </el-table-column>
            <el-table-column prop="orderSourceName" label="可用订单类型" width="200"></el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <!--<el-button type="success" size="mini" @click="handleAddFree(scope.row)">赠品</el-button>-->
                    <el-button type="warning " size="mini" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="设置折扣范围" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="会员等级">
                    <el-select v-model="form.level" placeholder="请选择">
                        <el-option
                                v-for="item in conditionList"
                                :key="item.level"
                                :label="item.levelName"
                                :value="item.level">
                        </el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="订单类型">
                    <el-checkbox-group v-model="selectOrderSource" @change="checkBaseDataItem"  size="small">
                        <el-checkbox v-for="item in sourceList" border size="medium" :label="item.value" :key="item.value"
                                     class="check-item">
                            {{item.name}}
                            </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getOrderSourceList,getVipDiscountRangeList,saveVipDiscountRangeEntity, conditionList} from '../../api/api'
    import selectPicComponents from '@/components/selectPic';
    //定义组件
    export default{
        data(){
            return {
                conditionList: [],
                selectOrderSource: [],
                sourceList:[],
                dialogFormVisible: false,
                dataList:[],
                form:{
                    level:null,
                    orderSource:null,
                },
                formInline: {
                    currentPage: 1,
                    recordsTotal: 0,
                    pageSize: 10,
                }
            }
        },
        components: {
            selectPicComponents
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList()
            this.getLevelList();
            this.getOrderSourceListDate()
        },
        methods: {
            //定义查询方法
            getLevelList(){
                this.loading = true;
                this.conditionList=[]
                conditionList(this.formInline).then((res) => {
                    this.loading = false;
                    console.log('levelList:'+res.data.list);
                    this.conditionList=res.data.list.filter(item=>{
                        return item.levelType==2
                    })
                    console.log('levelList:'+this.conditionList);
                })
            },
            getList(){
                getVipDiscountRangeList().then((res) => {
                    this.dataList = res.data;
                })
            },
            getOrderSourceListDate(){
                getOrderSourceList().then((res) => {
                    this.sourceList = res.data;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            changeLevelType(val){
            },
            handleAdd(){
                this.dialogFormVisible=true
            },
            handleEdit(row){
                this.dialogFormVisible=true
                this.form.level=row.level
                this.selectOrderSource=[]
                let arr=row.orderSource.split(",")
                for (let key of arr){
                    this.selectOrderSource.push(parseInt(key))
                }
                console.log('this.selectOrderSource='+this.selectOrderSource)
            },
            handleDelete(row){
                this.form.level=row.level
                this.selectOrderSource=[]
                this.selectOrderSource=row.orderSource.split(",")
            },
            save(){
                if(this.selectOrderSource.length==0){
                    this.$message({
                        showClose: true,
                        message: "订单类型必须选择",
                        type: 'error'
                    });
                    return;
                }
                this.form.orderSource=this.selectOrderSource.join(",")
                saveVipDiscountRangeEntity(this.form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible=false
                        this.getList()
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/vip/vipDiscountRange.vue